<template>
  <div>
    <div class="container">
      <div class="wrapper">
        <div class="head mb-5">
          <div class="justify-content-center row">
            <div class="col-lg-7 p-0">
              <ProgressHeader :currentStep="0" />
            </div>
          </div>
        </div>
        <div class="row justify-content-center" v-show="step == 1">
          <div class="col-lg-7">
            <div class="row align-items-top">
              <div class="col">
                <b-form-input
                  id="mobile"
                  type="tel"
                  placeholder="請輸入手機號碼"
                  v-model="$v.mobile.$model"
                  :state="validateState('mobile')"
                  @keyup.enter="onSubmitMobile"
                />
              </div>
              <div class="col-auto pl-0">
                <div :class="{ disabled: verifyingMobile || blocklist }" @click="onSubmitMobile">
                  <Button class="highlight" name="繼續" />
                </div>
              </div>
            </div>
            <div>
              <!-- 驗證錯誤顯示 -->
              <b-form-invalid-feedback v-if="$v.mobile.$dirty && $v.mobile.$error" class="d-block">
                <p>必填</p>
              </b-form-invalid-feedback>

              <!-- 驗證正確顯示 -->
              <p v-else class="text-muted">🔒 資料全程保密，由律所專屬保護</p>
            </div>

            <div class="col text-center">
              <img class="my-3" src="@/assets/pay_form_footer_banner.png" />
              <a href="javascript:;" @click="videoModalShow = true">一分鐘了解 PAMO 能幫你什麼？</a>
            </div>
            <!-- <div class="my-4 text-center" @click="videoModalShow = true">
              <span class="videoModalButton">1分鐘了解車禍線上律師</span>
            </div> -->
          </div>
        </div>
        <div class="row justify-content-center" v-show="step == 2">
          <div class="col-lg-7">
            <!-- 簡訊發送失敗：不顯示驗證碼輸入，直接跳通知 + 官方 LINE -->
            <div v-if="smsFailed" class="text-center">
              <h5 class="mb-3">感謝您的註冊！</h5>
              <p class="mb-1">我們已收到您的手機號碼 {{ mobile }}</p>
              <p class="mb-4 text-muted">
                簡訊驗證系統維護中，PAMO 將由專人盡快與您聯繫，協助您完成註冊。<br />
                您也可以點擊下方按鈕，立即透過官方 LINE 由專人協助。
              </p>
              <a class="line-button" href="https://lin.ee/SbFLz7Y" target="_blank">
                <span class="text-white">加入 PAMO 官方 LINE，立即協助 →</span>
              </a>
              <div class="mt-4">
                <b-link @click="step = 1"><b-icon icon="chevron-left"></b-icon>更改手機號碼</b-link>
              </div>
            </div>

            <!-- 正常流程：輸入驗證碼 -->
            <template v-else>
              <div class="row align-items-top">
                <div class="col">
                  <b-form-input
                    type="tel"
                    placeholder="輸入6位數驗證碼"
                    v-model="$v.code.$model"
                    maxlength="6"
                    :state="validateState('code')"
                    @keyup.enter="onSubmitCode"
                  />
                </div>
                <div class="col-auto pl-0">
                  <div :class="{ disabled: verifyingMobile }" @click="onSubmitCode">
                    <Button class="highlight" name="繼續" />
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col">
                  <b-link @click="step = 1"
                    ><b-icon icon="chevron-left"></b-icon>更改手機號碼</b-link
                  >
                </div>
                <div class="col-auto">
                  <b-link id="countdown" class="disabled" @click="onSubmitMobile"></b-link>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <VideoModal v-if="videoModalShow" :onClose="closeVideoModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { auth, plan } from '@/mixins';
import Button from '@/elements/Button.vue';
import ProgressHeader from '@/components/ProgressHeader.vue';
import VideoModal from '@/components/VideoModal.vue';
import { persistRefFromURL } from '@/utils/refTracker';

export default {
  mixins: [auth, plan, validationMixin],
  validations: {
    mobile: { required },
    code: { required },
  },
  computed: {
    ...mapState({
      profile: (state) => state.auth.profile,
      partnerAuthData: (state) => state.auth.partnerAuthData,
      verifyingMobile: (state) => state.auth.requesting,
    }),
  },
  data() {
    return {
      // 簡訊維護開關：every8d 故障期間設 true，登入失敗時改顯示通知頁而非錯誤彈窗；
      // 三竹簡訊上線後改回 false 即恢復原本行為
      smsMaintenance: true,
      // 本次登入發簡訊是否失敗：true 顯示 step 2 通知頁，false 走正常驗證碼流程
      smsFailed: false,
      refSource: 'unknown',
      videoModalShow: false,
      step: 1,
      mobile: '',
      code: '',
      blocklist: false,
      blockedNums: [
        '0917666979',
        '0911261421',
        '0919271105',
        '0906691175',
        '0919119265',
        '0975705131',
        '0960752158',
        '0900106279', // 陳昌謚，申請退費
        '0972228521', // 李沁惟，申請無使用退費
        '0953357118', // 胡瀚陽，申請無使用退費
        '0970602650', // 呂盛萌，260430申請無使用退費
        '0963016273', // 廖本立，260520申請無使用退費
        '0915136316', // 華定橙，申請退費
        '0956701115', // 王邑庭，申請無使用退費
        '0960590566', // 曾昰銘，續約後通報爭議款項
        '0970405138', // 許富捷，260810申請無使用退費
        '0932283064', // 260831申請無使用退費
        '0955815460', // 龔芳玉，續約後提報爭議款項申請退費
        '0929982298', // 林欣皞，20260907申請無使用退費
        '0906231026', // 林智濤，20260908申請無使用退費
        '0971265565', // 鄭羽農，不續約
        '0989209566', // 戴怡亭，無使用退費
        '0982938889', // 杜珆萱，無使用退費
      ],
    };
  },
  components: {
    Button,
    VideoModal,
    ProgressHeader,
  },
  mounted() {
    this.refSource = persistRefFromURL();
    if (this.$route.query.auth) {
      this.partnerAuth({
        authToken: this.$route.query.auth,
        onSuccess: () => {
          this.mobile = this.partnerAuthData.userData.phoneNumber;
        },
        onFailed: (err) => {
          alert(err.message);
        },
      });
    }
  },
  watch: {
    mobile: {
      handler() {
        if (this.blockedNums.includes(this.mobile)) {
          this.blocklist = true;
          alert('您的帳號受到限制，請與PAMO聯絡');
        }
      },
    },
  },
  methods: {
    closeVideoModal() {
      this.videoModalShow = false;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSubmitMobile() {
      this.$v.$touch();
      if (this.$v.mobile.$error) {
        return;
      }

      this.userLogin({
        mobile: this.mobile,
        onSuccess: () => {
          // 登入成功代表簡訊有送出 → 走正常驗證碼流程
          this.$v.$reset();
          this.smsFailed = false;
          this.step = 2;
          this.setTimer();
        },
        onFailed: () => {
          // 維護期間登入 API 會因後端發簡訊失敗回 500，但帳號與手機號其實已寫入
          // DB（afterCommit 才發簡訊），視為留資成功 → 進 step 2 顯示通知頁。
          if (this.smsMaintenance) {
            this.$v.$reset();
            this.smsFailed = true;
            this.step = 2;
          } else {
            alert('發生錯誤，請再試一次');
          }
        },
      });
    },
    setTimer() {
      let timeleft = 50;
      const downloadTimer = setInterval(function () {
        if (timeleft <= 0) {
          clearInterval(downloadTimer);
          document.getElementById('countdown').innerHTML = '重新發送驗證碼';
          document.getElementById('countdown').classList.remove('disabled');
        } else {
          document.getElementById('countdown').innerHTML = `${timeleft} 秒後重新發送驗證碼`;
          document.getElementById('countdown').classList.add('disabled');
        }
        timeleft -= 1;
      }, 1000);
    },
    onSubmitCode() {
      this.$v.$touch();
      if (this.$v.code.$error) {
        return;
      }

      this.verifyMobile({
        id: this.profile.id,
        code: this.code,
        onSuccess: () => {
          if (this.$route.query.auth) {
            if (this.profile.nationalId && (this.profile.licenses || []).length === 0) {
              // 有註冊過但還沒有序號，自動綁定
              this.addPlan({
                licenseKey: this.partnerAuthData.userData.licenseKey,
                onSuccess: () => {
                  this.$router.replace({
                    path: '/',
                    query: { auth: this.$route.query.auth, ref: this.refSource },
                  });
                },
                onFailed: () => {
                  alert('綁定序號時發生錯誤，請聯繫客服。');
                },
              });
            } else {
              this.$router.replace({
                path: '/',
                query: { auth: this.$route.query.auth, ref: this.refSource },
              });
            }
          } else {
            this.$router.replace({
              path: '/',
              query: { ref: this.refSource },
            });
          }
        },

        onFailed: () => {
          alert('驗證碼錯誤，請再試一次');
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '@/assets/lessjs/variables.less';
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.line-button {
  display: inline-block;
  background: #06c755;
  color: #fff;
  font-weight: bold;
  padding: 12px 28px;
  border-radius: 24px;
  text-decoration: none;
}
.line-button:hover {
  color: #fff;
  opacity: 0.9;
}
.videoModalButton {
  color: @highlight;
  font-weight: bold;
  text-decoration: underline;
}
.button {
  min-height: 40px;
}
</style>
